import React from 'react';

const Bonuses = () => {
  const bonuses = [
    {
      title: 'Bônus 01',
      name: 'SUPORTE DIRETO COM A PROFESSORA ONLINE',
      description: 'Você terá acesso direto comigo para ter suporte e tirar suas dúvidas.',
      oldPrice: 'Grátis',
      image: '/images/fundoSuporte.jpeg',
      layout: 'left' // imagem à esquerda, conteúdo à direita
    },
    {
      title: 'Bônus 02',
      name: 'EPILAÇÃO EGÍPCIA',
      description: 'Aprenda a fazer de forma profissional a técnica de epilação com a linha.',
      oldPrice: 'R$ 147,00',
      image: '/images/egipcio.jpeg',
      layout: 'right' // imagem à direita, conteúdo à esquerda
    },
    {
      title: 'Bônus 03',
      name: 'GUIA LUCRATIVO',
      description: 'O material que me acompanhou em 2025, agora como bônus para transformar sua vida.',
      oldPrice: 'R$ 147,00',
      image: '/images/guia.png',
      layout: 'left' // imagem à direita, conteúdo à esquerda
    }
  ];

  return (
    <section className="bonuses">
      <div className="container">
        <div className="bonuses-header">
          <p className="bonuses-header-line1">ADQUIRA HOJE E RECEBA</p>
          <p className="bonuses-header-line2">
            <span className="bonuses-header-number">05</span> BÔNUS ESPECIAIS!
          </p>
        </div>
        <div className="section-divider"></div>
        
        <div className="bonus-list">
          {bonuses.map((bonus, index) => (
            <div key={index} className={`bonus-item bonus-item-${bonus.layout}`}>
              <div className="bonus-title-box">{bonus.title}</div>
              <div className="bonus-content-wrapper">
                {bonus.layout === 'left' && (
                  <div className={`bonus-device ${bonus.title === 'Bônus 03' ? 'bonus-device-guia' : ''}`}>
                    <img 
                      src={bonus.image} 
                      alt={bonus.name}
                    />
                  </div>
                )}
                <div className="bonus-content">
                  <h3>{bonus.name}</h3>
                  <p>{bonus.description}</p>
                  {/* <div className="bonus-old-price">Custa <span className="bonus-price-strikethrough">{bonus.oldPrice}</span></div> */}
                </div>
                {bonus.layout === 'right' && (
                  <div className={`bonus-device ${bonus.title === 'Bônus 03' ? 'bonus-device-guia' : ''}`}>
                    <img 
                      src={bonus.image} 
                      alt={bonus.name}
                    />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
        
        <div className="bonus-summary">
          <p className="bonus-summary-text">
            Mais de 20 aulas, explicadas de forma simples e objetiva, para você aprender Henna com segurança e confiança, mesmo que esteja começando do zero.
          </p>
          <p className="bonus-highlight">
            <strong>Tudo isso por apenas<br /><span className="bonus-price-highlight">R$ 77,90</span></strong>
          </p>
          <a href="https://pay.kiwify.com.br/TXv8v09" target="_blank" rel="noopener noreferrer" className="bonus-cta-button">
            Sim, quero começar agora!
          </a>
          <p className="bonus-payment-text">
            Um investimento acessível para quem quer entrar na área da beleza ou adicionar mais um serviço ao atendimento.
          </p>
          <p className="bonus-value-text">
            Sem promessas irreais.<br />
            Sem teoria desnecessária.<br />
            Apenas o essencial para você aprender e aplicar.
          </p>
          <p className="bonus-social-proof">
            Eu acredito no meu método e sei que ele pode transformar sua vida como já transformou a de várias alunas. <br />
            Então, não deixe essa chance passar, aproveite agora.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Bonuses;

